/** Human labels for VendorDocumentType — shared by the vendor detail panel and RFC-228 Trust API card. */
export const DOC_TYPE_LABELS: Record<string, string> = {
  trust_center: 'Trust Center',
  soc2_report: 'SOC 2 Report',
  iso27001_cert: 'ISO 27001',
  security_questionnaire: 'Questionnaire',
  dpa: 'DPA',
  msa: 'MSA',
  sla: 'SLA',
  tos: 'Terms of Service',
  nda: 'NDA',
  pentest_report: 'Pentest Report',
  privacy_policy: 'Privacy Policy',
  ai_data_policy: 'AI Data Policy',
  vuln_mgmt_policy: 'Vuln Mgmt Policy',
  subprocessor_list: 'Subprocessor List',
  other: 'Other',
}
